import * as React from "react";
import { DatePicker } from "../../../../../../react-core/Datepicker/DatePicker";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { addDays, addMonths } from "../../../../../../react-core/utils/date";
import { AdviserWizardAction } from "../../../../../Admin/Adviser/Actions/AdviserWizardAction";
import { DateRange } from "../../../../../Shared/Components/DateRange";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { datePickerOptions } from "../../../Clients/Common/Resource/Contents";

interface IAviserDropdownProps {
    onSearch: (advisor, from, to?, dateSelected?: string) => void;
    isFromTo: boolean;
}

export const AdviserDropdown = (props: IAviserDropdownProps) => {
    const [advisors, setAdvisors] = React.useState([]);
    const [advisor, setAdvisor] = React.useState(null);
    const [asAt, setAsAt] = React.useState(addDays(new Date(), -1));
    const [from, setFrom] = React.useState(addMonths(new Date(), -3));
    const [to, setTo] = React.useState(addDays(new Date(), -1));
    const [dateSelected, setDateSelected] = React.useState("Past 3 months");

    React.useEffect(() => {
        AdviserWizardAction.getAdviser(
            { Company: getQueryParameters()["code"], Network: null, CurrentPage: 1, ResultsPerPage: 999 },
            (d) => {
                setAdvisors([null].concat(d.Results));
            }
        );
    }, []);

    return (
        <>
            {!props.isFromTo && (
                <div className="row narrow-gutter">
                    <div className="col-12 col-sm-3">
                        <SelectEditor
                            label="Adviser"
                            options={advisors}
                            onChange={(d) => setAdvisor(d)}
                            getText={(o) => (o ? o.Name : "All")}
                            selected={advisor}
                        />
                    </div>
                    <div className="col-12 col-sm-2">
                        <DatePicker
                            label="As at"
                            onChange={(d) => setAsAt(d)}
                            selected={asAt}
                            {...datePickerOptions}
                            todayButton={null}
                            lessThan={{
                                value: new Date(),
                                errorMessage: "Date can not be today or future",
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-auto col-middle">
                        <button className="btn secondary mt-5" onClick={() => props.onSearch(advisor, asAt)}>
                            Submit
                        </button>
                    </div>
                </div>
            )}
            {props.isFromTo && (
                <div className="row narrow-gutter mb-50">
                    <div className="col-12 col-sm-3">
                        <SelectEditor
                            label="Adviser"
                            options={advisors}
                            onChange={(d) => setAdvisor(d)}
                            getText={(o) => (o ? o.Name : "All")}
                            selected={advisor}
                        />
                    </div>
                    <div className="col-12 col-sm-auto col-middle">
                        <DateRange
                            minDate={null}
                            fromDate={from}
                            toDate={to}
                            cssGridDate="col-12 col-sm-auto"
                            cssGridTo="col-12 col-sm-auto"
                            cssGridFrom="col-12 col-sm-auto"
                            cssGridLabel="col-12 col-sm-auto col-middle"
                            selectValue={"6"} // Past 3 month
                            onChange={(from, to, fromInception, dateSelected) => {
                                setFrom(from);
                                setTo(to);
                                setDateSelected(dateSelected);
                            }}
                            excludeToday
                            excludeSinceAccountOpening
                            maxDate={addDays(new Date(), -1)}
                        />
                    </div>

                    <div className="col-12 col-sm-auto col-middle">
                        <button
                            className="btn secondary mt-5"
                            onClick={() => props.onSearch(advisor, from, to, dateSelected)}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};
